import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { returnType } from "../../Utilities/ReturnType";
import { onConfigurationSettingClose } from "../../../redux/Actions/PowerDataQuery";
import {
  DetailsList,
  DefaultButton,
  Dialog,
  DialogFooter,
  DialogType,
  Selection,
  SelectionMode,
  DetailsListLayoutMode,
  IconButton,
  IIconProps,
  MarqueeSelection,
  PrimaryButton,
  IColumn,
  CheckboxVisibility,
  Icon,
} from "@fluentui/react";

import { GlobalDataQuery } from "../../Interface/IPowerQuery";

import "./ConfigurationSettingsDialog.css";

const forwardIcon: IIconProps = { iconName: "Forward" };
const backIcon: IIconProps = { iconName: "Back" };
const upIcon: IIconProps = { iconName: "Up" };
const downIcon: IIconProps = { iconName: "Down" };

const mapStateToProps = (state: GlobalDataQuery) => ({
  indexList: state.indexList,
  index: state.index,
  isOpen: state.layout.showConfigrationDialog,
  metadataFields:
    state.metadataFields &&
    state.index &&
    state.index.metadataSchema &&
    state.metadataFields[state.index.metadataSchema],
});

const actionCreators = {
    onConfigurationSettingClose
};
type DispatchProps = typeof actionCreators;

const storeProps = returnType(mapStateToProps);
type StoreProps = typeof storeProps.returnType;

class ConfigurationSettingsDialog extends Component<StoreProps & DispatchProps> {
  render() {
    if (!this.props.isOpen) return null

    return (
      <Dialog
        hidden={!this.props.isOpen}
        dialogContentProps={{
          type: DialogType.normal,
          subText: "",
        }}
        modalProps={{ isBlocking: true }}
        onDismiss = {this.props.onConfigurationSettingClose}
        title="Column options"
      >
        <div className="dialog-tbl">aaamm</div>

        <DialogFooter>
          <PrimaryButton
            onClick={this.props.onConfigurationSettingClose}
          >OK</PrimaryButton>
          <DefaultButton
            onClick={this.props.onConfigurationSettingClose}
          >Cancel</DefaultButton>
        </DialogFooter>
      </Dialog>
    );
  }
}

export default connect<StoreProps, DispatchProps>(
  mapStateToProps,
  bindActionCreators.bind({}, actionCreators)
)(ConfigurationSettingsDialog);
